<template>
  <div>
    <nav aria-label='breadcrumb'>
      <ol class='breadcrumb'>
        <li class='breadcrumb-item'>
          <a href='/archive-users'>{{ translations('account_setting.account_manage') }}</a>
        </li>
        <li class='breadcrumb-item'>
          <router-link to='/archive-users'>{{ translations('account_setting.user_list') }}</router-link>
        </li>
        <li v-if="this.withUsersID" class='breadcrumb-item active' aria-current='page'>{{ translations('account_setting.user_detail') }}</li>
        <li v-else class='breadcrumb-item active' aria-current='page'>{{ translations('account_setting.user_register') }}</li>
      </ol>
    </nav>
    <div class='container-fluid main-container'>
      <div class='d-flex flex-wrap'>
        <div class='left-container'>
          <div>
            <h6 v-if="(Number(usersDetails.allow_cost_download) === 1)" class='mb-3 approval text-danger'>
              {{ translations('account_setting.message_approval_cost_download') }}</h6>
          </div>
          <h5 class='mb-3'>Information</h5>
          <table class='table table-sm table-borderless table-information'>
            <tbody>
              <tr>
                <th>{{ translations('account_setting.username') }}</th>
                <td>
                  <button
                    ref='info01'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info01'
                    data-placement='right'
                  >{{ usersDetails.user_name ? usersDetails.user_name : '-----------' }}</button>
                  <div id='popover-info01' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('account_setting.username') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempDetails.user_name" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button v-if="isAdmin" type='submit' class='btn btn-sm btn-primary' @click="updateField('user_name', tempDetails.user_name, 'info01')">
                        {{ translations('common.update') }}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('account_setting.permission') }}</th>
                <td>
                  <button
                    ref='info02'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info02'
                    data-placement='right'
                  >{{ usersDetails.user_privilege ? usersDetails.user_privilege : '-----------' }}</button>
                  <div id='popover-info02' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('account_setting.permission') }}
                    </div>
                    <div class='popover-body popover-content'>
                     <select class='custom-select' v-model="tempDetails.privilege_id">
                        <option v-for="(privilege, i) in privileges" :key="i" :value='privilege.id'>{{ privilege.name }}</option>
                      </select>
                    </div>
                    <div class='popover-footer'>
                      <button v-if="isAdmin" type='submit' class='btn btn-sm btn-primary' @click="updateField('privilege_id', tempDetails.privilege_id, 'info02')">
                        {{ translations('common.update') }}</button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('account_setting.cost_download') }}</th>
                <td>
                  <button
                    ref='info11'
                    type='button'
                    :class="(Number(usersDetails.allow_cost_download) === 1) ? 'btn btn-link p-0 text-danger' : 'btn btn-link p-0'"
                    data-toggle='popover-x'
                    data-target='#popover-info11'
                    data-placement='right'
                  >{{ usersDetails.allow_cost_download ? getAllowCostDownloadLabel(usersDetails.allow_cost_download) : '-----------' }}</button>
                  <div id='popover-info11' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('account_setting.cost_download') }}
                    </div>
                    <div class='popover-body popover-content'>
                     <select class='custom-select' v-model="tempDetails.allow_cost_download">
                        <option v-for="(allow, i) in translationAllow" :key="i" :value='allow.id'>{{ allow.name }}</option>
                      </select>
                    </div>
                    <div class='popover-footer'>
                      <button v-if="isAdmin" type='submit' class='btn btn-sm btn-primary' @click="updateField('allow_cost_download', tempDetails.allow_cost_download, 'info11')">
                        {{ translations('common.update') }}
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('account_setting.email_address') }}</th>
                <td>
                  <button
                    ref='info03'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info03'
                    data-placement='right'
                  >{{ usersDetails.email ? usersDetails.email : '-----------' }}</button>
                  <div id='popover-info03' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('account_setting.email_address') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempDetails.email" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button v-if="isAdmin" type='submit' class='btn btn-sm btn-primary' @click="updateField('email', tempDetails.email, 'info03')">
                        {{ translations('common.update') }}
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('account_setting.password') }}</th>
                <td>
                  <button
                    ref='info04'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info04'
                    data-placement='right'
                  >-----------</button>
                  <div id='popover-info04' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('account_setting.password') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempDetails.password" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button v-if="isAdmin" type='submit' class='btn btn-sm btn-primary' @click="updateField('password', tempDetails.password, 'info04')">
                        {{ translations('common.update') }}
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('account_setting.department_classification') }}</th>
                <td>
                  <button
                    ref='info06'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info06'
                    data-placement='right'
                  >{{ usersDetails.user_division ? usersDetails.user_division : '-----------' }}</button>
                  <div id='popover-info06' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('account_setting.department_classification') }}
                    </div>
                    <div class='popover-body popover-content'>
                     <select class='custom-select' v-model="tempDetails.division_id">
                        <option v-for="(division, i) in divisions" :key="i" :value='division.id'>{{ division.name }}</option>
                      </select>
                    </div>
                    <div class='popover-footer'>
                      <button v-if="isAdmin" type='submit' class='btn btn-sm btn-primary' @click="updateField('division_id', tempDetails.division_id, 'info06')">
                        {{ translations('common.update') }}
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('account_setting.employee_classification') }}</th>
                <td>
                  <button
                    ref='info07'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info07'
                    data-placement='right'
                  >{{ usersDetails.user_position ? usersDetails.user_position : '-----------' }}</button>
                  <div id='popover-info07' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('account_setting.employee_classification') }}
                    </div>
                    <div class='popover-body popover-content'>
                     <select class='custom-select' v-model="tempDetails.position_id">
                        <option v-for="(position, i) in positions" :key="i" :value='position.id'>{{ position.name }}</option>
                      </select>
                    </div>
                    <div class='popover-footer'>
                      <button v-if="isAdmin" type='submit' class='btn btn-sm btn-primary' @click="updateField('position_id', tempDetails.position_id, 'info07')">
                        {{ translations('common.update') }}
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th>{{ translations('account_setting.gender') }}</th>
                <td>
                  <button
                    ref='info08'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info08'
                    data-placement='right'
                  >{{ usersDetails.gender ? getGenderLabel(usersDetails.gender) : '-----------' }}</button>
                  <div id='popover-info08' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('account_setting.gender') }}
                    </div>
                    <div class='popover-body popover-content'>
                     <select class='custom-select' v-model="tempDetails.gender">
                        <option v-for="(gender, i) in translationGender" :key="i" :value='gender.id'>{{ gender.name }}</option>
                      </select>
                    </div>
                    <div class='popover-footer'>
                      <button v-if="isAdmin" type='submit' class='btn btn-sm btn-primary' @click="updateField('gender', tempDetails.gender, 'info08')">
                        {{ translations('common.update') }}
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                  <th>{{ translations('account_setting.hire_date') }}</th>
                  <td>
                      <button ref="info09" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info09' data-placement='right'>{{ tempDetails.join_date ? $invoiceTools.formatDate(tempDetails.join_date) : '--------------' }}</button>
                      <div id='popover-info09' class='popover popover-x popover-default'>
                          <div class='arrow'></div>
                          <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('account_setting.hire_date') }}</div>
                          <div class='popover-body popover-content'>
                            <input type='date' v-model="tempDetails.join_date" class='form-control'>
                          </div>
                          <div class='popover-footer'>
                            <button v-if="isAdmin" type='submit' v-on:click="updateField('join_date', tempDetails.join_date, 'info09')" class='btn btn-sm btn-primary'>
                              {{ translations('common.update') }}
                            </button>
                          </div>
                      </div>
                  </td>
              </tr>
              <tr>
                  <th>{{ translations('account_setting.birthday') }}</th>
                  <td>
                      <button ref="info10" type='button' class='btn btn-link p-0' data-toggle='popover-x' data-target='#popover-info10' data-placement='right'>{{ tempDetails.birthday ? $invoiceTools.formatDate(tempDetails.birthday) : '--------------' }}</button>
                      <div id='popover-info10' class='popover popover-x popover-default'>
                          <div class='arrow'></div>
                          <div class='popover-header popover-title'><button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('account_setting.birthday') }}</div>
                          <div class='popover-body popover-content'>
                            <input type='date' v-model="tempDetails.birthday" class='form-control'>
                          </div>
                          <div class='popover-footer'>
                            <button v-if="isAdmin" type='submit' v-on:click="updateField('birthday', tempDetails.birthday, 'info10')" class='btn btn-sm btn-primary'>
                              {{ translations('common.update') }}
                            </button>
                          </div>
                      </div>
                  </td>
              </tr>
              <tr>
                <th>{{ translations('account_setting.remarks') }}</th>
                <td>
                  <button
                    ref='info05'
                    type='button'
                    class='btn btn-link p-0'
                    data-toggle='popover-x'
                    data-target='#popover-info05'
                    data-placement='right'
                  >{{ usersDetails.memo ? usersDetails.memo : '-----------' }}</button>
                  <div id='popover-info05' class='popover popover-x popover-default'>
                    <div class='arrow'></div>
                    <div class='popover-header popover-title'>
                      <button class='close' data-dismiss='popover-x'>&times;</button>{{ translations('account_setting.remarks') }}
                    </div>
                    <div class='popover-body popover-content'>
                      <input type='text' v-model="tempDetails.memo" class='form-control'>
                    </div>
                    <div class='popover-footer'>
                      <button v-if="isAdmin" type='submit' class='btn btn-sm btn-primary' @click="updateField('memo', tempDetails.memo, 'info05')">
                        {{ translations('common.update') }}
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <hr>
          <div class="form-inline">
            <div v-if="!withUsersID" class="form-group">
              <button v-if="isAdmin" class="btn btn-primary" @click="createUsers()">{{ translations('common.register') }}</button>
            </div>
            <div v-else class="form-group">
              <a v-if="isAdmin" class="btn btn-link btn-sm text-danger" data-href="#" @click.self="deleteUsers()">{{ translations('common.delete') }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vue-element-loading :active='isLoading' :is-full-screen='true'/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'SingleUsers',
  props: {},
  components: {
    VueElementLoading
  },

  data () {
    return {
      usersID: 0,
      withUsersID: false,
      privileges: [],
      divisions: [],
      positions: [],
      allows: [{ id: 0, name: '' }, { id: 1, name: '申請中' }, { id: 2, name: '承認済' }],
      genders: [{ id: 1, name: '男性' }, { id: 2, name: '女性' }, { id: 3, name: 'その他' }],
      usersDetails: {},
      tempDetails: {},
      isLoading: true
    }
  },

  watch: {
    'tempDetails.user_privilege': {
      handler (d) {
        this.privileges.forEach(v => {
          if (v.name === this.tempDetails.user_privilege) {
            this.tempDetails.privilege_id = v.id
          }
        })
      },
      deep: true
    }
  },

  created () {
    if (this.$route.query.user_id) {
      // Update user.
      this.withUsersID = true
      this.usersID = this.$route.query.user_id
      this.getUsers()
    } else {
      // Create user.
      this.withUsersID = false
    }

    this.listPrivileges()
    this.listDivisions()
    this.listPositions()
  },

  mounted: function () {
    this.isLoading = false
    this.popoverButtons()
  },
  computed: {
    ...mapState(['currentLanguage']),
    isAdmin: function () {
      return this.$store.getters['User/isAdmin']
    },
    translationGender () {
      return this.genders.map(gender => ({
        ...gender,
        name: this.translations(`gender.${gender.id}`)
      }))
    },
    translationAllow () {
      return this.allows.map(allow => ({
        ...allow,
        name: allow.id === 0 ? '' : this.translations(`allow.${allow.id}`)
      }))
    }
  },

  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getAllowCostDownloadLabel (status) {
      if (Number(status) === 1) {
        return this.translations('account_setting.pending')
      } else if (Number(status) === 2) {
        return this.translations('account_setting.approved')
      }
      return '-----------'
    },
    getGenderLabel (status) {
      if (Number(status) === 1) {
        return this.translations('account_setting.male')
      } else if (Number(status) === 2) {
        return this.translations('account_setting.female')
      }
      return this.translations('account_setting.other')
    },
    async listPrivileges () {
      try {
        let pList = await this.$http.post(this.$api_url.account_privilege_list)
        let $data = this.$invoiceTools.prepareResult(pList.data, 'list', 'SingleUsers:listPrivileges')
        if ($data.success === true) {
          this.privileges = $data.data
        } else {
          this.privileges = [{ id: 0, name: 'No record.' }]
          this.$toastr.error($data.data, 'エラー')
        }
      } catch (error) {
        console.log('SingleUsers:listPrivileges:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },
    async listDivisions () {
      try {
        let pList = await this.$http.post(this.$api_url.account_division_list)
        let $data = this.$invoiceTools.prepareResult(pList.data, 'list', 'SingleUsers:listDivisions')
        if ($data.success === true) {
          this.divisions = $data.data
        } else {
          this.divisions = [{ id: 0, name: 'No record.' }]
          this.$toastr.error($data.data, 'エラー')
        }
      } catch (error) {
        console.log('SingleUsers:listDivisions:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },
    async listPositions () {
      try {
        let pList = await this.$http.post(this.$api_url.account_position_list)
        let $data = this.$invoiceTools.prepareResult(pList.data, 'list', 'SingleUsers:listPositions')
        if ($data.success === true) {
          this.positions = $data.data
        } else {
          this.positions = [{ id: 0, name: 'No record.' }]
          this.$toastr.error($data.data, 'エラー')
        }
      } catch (error) {
        console.log('SingleUsers:listPositions:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    async getUsers () {
      try {
        let result = await this.$http.post(
          this.$api_url.account_details,
          { user_id: this.usersID }
        )
        if (result.data.status === true) {
          this.usersDetails = {
            user_name: result.data.details.user_name,
            privilege_id: result.data.details.privilege_id,
            allow_cost_download: result.data.details.allow_cost_download,
            user_privilege: result.data.details.user_privilege,
            division_id: result.data.details.division_id,
            user_division: result.data.details.user_division,
            position_id: result.data.details.position_id,
            user_position: result.data.details.user_position,
            email: result.data.details.email,
            memo: result.data.details.memo,
            birthday: result.data.details.birthday,
            join_date: result.data.details.join_date,
            gender: result.data.details.gender
          }
          this.tempDetails = this.usersDetails
        } else {
          self.$toastr.error(result.message, 'エラー')
        }
      } catch (error) {
        console.log('SingleUsers:getUsers:catch(error): ', JSON.stringify(error))
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    popoverButtons () {
      window.$('button[data-toggle="popover-x"]').each(function () {
        let targetID = window.$(this).attr('data-target')
        window.$(this).popoverButton({
          target: targetID,
          trigger: 'click'
        })
      })
    },

    updateField (field, value, ref) {
      let $this = this
      let val = ''
      const rg = /^\s+$/
      if (
        value === '-' ||
        value === '' ||
        rg.test(value) === true ||
        typeof value === 'undefined'
      ) {
        this.$refs[ref].innerText = '-----------'
        val = ''
      } else if (field === 'privilege_id') {
        this.privileges.forEach(function (v) {
          if (v.id === value) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'division_id') {
        this.divisions.forEach(function (v) {
          if (v.id === value) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'position_id') {
        this.positions.forEach(function (v) {
          if (v.id === value) {
            $this.$refs[ref].innerText = v.name
            val = v.id
          }
        })
      } else if (field === 'allow_cost_download') {
        const fVal = this.getAllowCostDownloadLabel(value)
        this.$refs[ref].innerText = fVal
        val = value
      } else if (field === 'gender') {
        const fVal = this.getGenderLabel(value)
        this.$refs[ref].innerText = fVal
        val = value
      } else if (field === 'join_date') {
        const fDate = this.$invoiceTools.formatDate(value, 1)
        this.$refs[ref].innerText = fDate
        val = fDate
      } else if (field === 'birthday') {
        const fDate = this.$invoiceTools.formatDate(value, 1)
        this.$refs[ref].innerText = fDate
        val = fDate
      } else {
        this.$refs[ref].innerText = value
        val = value
      }
      this.usersDetails[field] = val

      if (this.withUsersID) {
        this.updateUsers(field, val, ref)
      } else {
        window.$('#popover-' + ref).popoverX('hide')
      }
    },

    async updateUsers (field, val, ref) {
      try {
        let paramUpdate = {}
        paramUpdate[field] = val
        paramUpdate.user_id = this.usersID
        console.log('params', paramUpdate)

        let updateUser = await this.$http.post(this.$api_url.account_update, paramUpdate)
        let $data = this.$invoiceTools.prepareResult(updateUser.data)
        console.log('SingleUsers:updateUsers: ', $data)
        if ($data.success === true) {
          this.$toastr.success('ユーザの保存に成功しました。', 'Success')
          window.$('#popover-' + ref).popoverX('hide')
        } else {
          this.$toastr.error($data.data, 'エラー')
        }
      } catch (error) {
        console.log('SingleUsers:updateUsers:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }
    },

    createUsers () {
      this.$dialog.confirm('このユーザを保存しますか?').then(async () => {
        try {
          let paramUpdate = this.usersDetails
          console.log('params', paramUpdate)

          let createUser = await this.$http.post(this.$api_url.account_add, paramUpdate)
          let $data = this.$invoiceTools.prepareResult(createUser.data)
          console.log('SingleUsers:createUsers: ', $data)
          if ($data.success === true) {
            this.$toastr.success('ユーザの保存に成功しました。', 'Success')
            this.$router.push('/archive-users')
          } else {
            this.$toastr.error($data.data, 'エラー')
          }
        } catch (error) {
          // console.log('SingleUsers:createUsers:catch(error): ', error)
          // this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        }
      })
    },

    deleteUsers () {
      this.$dialog.confirm('このユーザを削除しますか?')
        .then(async () => {
          this.isLoading = true
          try {
            let del = await this.$http.post(this.$api_url.account_delete, { user_id: this.usersID })
            let $data = this.$invoiceTools.prepareResult(del.data, '', 'SingleUsers:deleteUsers')
            if ($data.success === true) {
              this.$toastr.success('ユーザを削除しました', 'Success')
              this.$router.replace('/archive-users')
            } else {
              this.$toastr.error($data.data, 'エラー')
            }
            this.isLoading = false
          } catch (error) {
            this.isLoading = false
            console.log('SingleUsers:deleteUsers:catch(error): ', error)
            this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
          }
        }).catch(() => { console.log('Clicked `Cancel`') })
    }
  }
}
</script>
